import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertConta'
})
export class ConvertBancoPipe implements PipeTransform {

  transform(value: any, args?: any): any {
   if (value) {
     return 'Conta Corrente';
   }
    return 'Conta Poupança';
  }
}
